import React, {Component} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { sendDetailsToDownloadFile } from './UserFunctions';
import PropTypes from 'prop-types';

class ScenarioCatalogueTable extends Component {
    constructor(props){
        super(props)
        this.state = {
            descriptionSelectedRow: undefined,
            imageSelectedRow: undefined
        }
        this.handleShowDescription = this.handleShowDescription.bind(this);
        this.handleShowImage = this.handleShowImage.bind(this);
        this.closeDescriptionModal = this.closeDescriptionModal.bind(this);
        this.closeImageModal = this.closeImageModal.bind(this);
        this.downloadXOSCFile = this.downloadXOSCFile.bind(this);
    }

    handleShowDescription(e) {
        const index = e.target.id;
        this.setState((prevState) => {
            return{
                descriptionSelectedRow: index,
                imageSelectedRow: prevState.imageSelectedRow
            }
        })
    }

    handleShowImage(e) {
        const index = e.target.id;
        this.setState( (prevState) => {
            return{
                descriptionSelectedRow: prevState.descriptionSelectedRow,
                imageSelectedRow: index
            }
        })
    }

    closeDescriptionModal() {
        this.setState( (prevState) => {
            return{
                descriptionSelectedRow: undefined,
                imageSelectedRow: prevState.imageSelectedRow
            }
        })
    }

    closeImageModal() {
        this.setState( (prevState) => {
            return{
                descriptionSelectedRow: prevState.descriptionSelectedRow,
                imageSelectedRow: undefined
            }
        })
    }

    downloadXOSCFile(event) {
        const index = event.target.value;
        let scenario_id = this.props.scenarioCatalogueData[index].scenario_ui_id;
        const payload = { scenario_id }
        sendDetailsToDownloadFile(payload).then((response) => {
            if(response){
                if(response.status === 200){
                    let fileName = response.headers["content-disposition"].split("filename=")[1];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                            fileName);
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                        document.body.appendChild(link);
                        link.click();
                    }
                }
            }
        })
    }
    // class ScenarioCatalogueTable extends Component {
    //     constructor(props){
    //         super(props)
    //         this.state = {
    //             descriptionSelectedRow: undefined,
    //             imageSelectedRow: undefined
    //         }
    //         this.handleShowDescription = this.handleShowDescription.bind(this);
    //         this.handleShowImage = this.handleShowImage.bind(this);
    //         this.closeDescriptionModal = this.closeDescriptionModal.bind(this);
    //         this.closeImageModal = this.closeImageModal.bind(this);
    //         this.downloadXOSCFile = this.downloadXOSCFile.bind(this);
    //     }
    
    //     handleShowDescription(e) {
    //         const index = e.target.id;
    //         this.setState((prevState) => {
    //             return{
    //                 descriptionSelectedRow: index,
    //                 imageSelectedRow: prevState.imageSelectedRow
    //             }
    //         })
    //     }
    
    //     handleShowImage(e) {
    //         const index = e.target.id;
    //         this.setState( (prevState) => {
    //             return{
    //                 descriptionSelectedRow: prevState.descriptionSelectedRow,
    //                 imageSelectedRow: index
    //             }
    //         })
    //     }
    
    //     closeDescriptionModal() {
    //         this.setState( (prevState) => {
    //             return{
    //                 descriptionSelectedRow: undefined,
    //                 imageSelectedRow: prevState.imageSelectedRow
    //             }
    //         })
    //     }
    
    //     closeImageModal() {
    //         this.setState( (prevState) => {
    //             return{
    //                 descriptionSelectedRow: prevState.descriptionSelectedRow,
    //                 imageSelectedRow: undefined
    //             }
    //         })
    //     }
    
    //     downloadXOSCFile(event) {
    //         const index = event.target.value;
    //         let scenario_id = this.props.scenarioCatalogueData[index].scenario_ui_id;
    //         const payload = { scenario_id }
    //         sendDetailsToDownloadFile(payload).then((response) => {
    //             if(response){
    //                 if(response.status === 200){
    //                     let fileName = response.headers["content-disposition"].split("filename=")[1];
    //                     if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
    //                         window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
    //                             fileName);
    //                     } else {
    //                         const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    //                         const link = document.createElement('a');
    //                         link.href = url;
    //                         link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
    //                         document.body.appendChild(link);
    //                         link.click();
    //                     }
    //                 }
    //             }
    //         })
    //     }
    
    render () {
        const acc = ['KPIT_ACC_002', 'KPIT_ACC_003', 'KPIT_ACC_007'];
        const aeb = ['KPIT_AEB_001', 'KPIT_AEB_002', 'KPIT_AEB_020', 'KPIT_AEB_022'];
        const baseUrl = "data:image/png;base64,";
        return (
        <section data-test = 'scenarioCatalogueTableComponent' className="content">
            <div className="container-fluid">
            {this.props.scenarioCatalogueData.length > 0 ?
                <table className="table">
                    <thead>
                        <tr className="table-head">
                            <th scope="col" key="scenario_uuid">Scenario ID</th>
                            <th scope="col" key="geography_applicability">Geography Applicability</th>
                            <th scope="col" key="strategy_mapping" style={{ display: "none" }}>Strategy Mapping</th>
                            <th scope="col" key="geometry" style={{ display: "none" }}>Geometry</th>
                            <th scope="col" key="feature_mapping" style={{ display: "none" }}>Feature Mapping</th>
                            <th scope="col" key="logical_component" style={{ display: "none" }}>Logical Component</th>
                            <th scope="col" key="function_mapping" style={{ display: "none" }}>Function Mapping</th>
                            <th scope="col" key="scenario_description">Scenario Description</th>
                            <th scope="col" key="scenario_representation">Scenario Representation</th>
                            <th scope="col" key="scenario_type">Scenario Type</th>
                            <th scope="col" key="scenario_classification">Scenario Classification</th>
                            <th scope="col" key="category">Category</th>
                            <th scope="col" key="tools">Tools</th>
                            <th scope="col" key="standards" style={{ display: "none" }}>Standards</th>
                            <th scope="col" key="customer_specific" style={{ display: "none" }}>Customer Specific</th>
                            <th scope="col" key="scenario_location" style={{ display: "none" }}>Scenario Location</th>
                            <th scope="col" key="Action" style={ window.location.pathname.includes('/view_scenario_catalogue') === true ? {} : { display: "none" }}>Action</th>
                            <th scope="col" key="Video" style={ window.location.pathname.includes('/view_scenario_catalogue') === true ? {} : { display: "none" }}>Video</th>
                        </tr>
                    </thead>
                      <tbody>
                        {this.props.scenarioCatalogueData.map( (element, index) => {
                            let videoUrl = false;
                            try {
                                if (element.scenario_ui_id in acc || element.scenario_ui_id in aeb){
                                    videoUrl = require(`./../video/${element.scenario_ui_id}.mp4`) 
                                } else if (element.scenario_ui_id.includes('KPIT_ACC_') && acc.includes(element.scenario_ui_id) === false ) {
                                    videoUrl = require(`./../video/KPIT_ACC_002.mp4`)
                                } else if (element.scenario_ui_id.includes('KPIT_AEB_') && aeb.includes(element.scenario_ui_id) === false ) {
                                    videoUrl = require(`./../video/KPIT_AEB_001.mp4`)
                                } else {
                                    videoUrl = require(`./../video/${element.scenario_ui_id}.mp4`)
                                }
                            }
                            catch (error){
                                console.log(error);
                            }
                            return (<tr key={index} valign="middle" className="table-row" style={{ verticalAlign: "text-top" }}>
                                        <td>{element.scenario_ui_id}</td>
                                        <td>{element.geography_applicability}</td>
                                        <td style={{ display: "none" }}>{element.strategy_mapping}</td>
                                        <td style={{ display: "none" }}>{element.geometry}</td>
                                        <td style={{ display: "none" }}>{element.feature_mapping}</td>
                                        <td style={{ display: "none" }}>{element.logical_component}</td>
                                        <td style={{ display: "none" }}>{element.function_mapping}</td>
                                        <td>
                                            <div id={index} className="description-width"
                                                onClick={ (e) => { this.handleShowDescription(e) } }>
                                                {element.scenario_description}
                                            </div>
                                        </td>
                                        {element.img.includes("Image not Found") ?
                                        <p>Image not Found</p>
                                        :<td value={index}>
                                            <img src={`${baseUrl}${element.img.replace(/['"]+/g, '')}`}
                                                id={index}
                                                alt=""
                                                style={{ cursor: 'pointer' }}
                                                onClick={ (e) => {this.handleShowImage(e)} }
                                                width="150"
                                                height="100"
                                            ></img>
                                        </td>}
                                        <td>{element.scenario_type}</td>
                                        <td>{element.scenario_classification}</td>
                                        <td>{element.category}</td>
                                        <td>{element.tools}</td>
                                        <td style={{ display: "none" }}>{element.standards}</td>
                                        <td style={{ display: "none" }}>{element.customer_specific}</td>
                                        <td style={{ display: "none" }}>{element.scenario_location}</td>
                                        { window.location.pathname.includes('/view_scenario_catalogue') === true ?
                                            <td>
                                                {element.is_xosc_file_available === true || element.scenario_ui_id.includes('KPIT_ACC') || element.scenario_ui_id.includes('KPIT_AEB') ?
                                                <button className='btn' value={index} onClick={(e) => {this.downloadXOSCFile(e)}}>Download XOSC</button>
                                                : <p>XOSC file unavailable</p>}
                                            </td>
                                        : undefined}
                                        { window.location.pathname.includes('/view_scenario_catalogue') === true ?
                                            <td>
                                                {videoUrl === false ?
                                                <p>Video unavailable</p>
                                                : (<video width="200" height="100" controls>
                                                    <source src={videoUrl} type="video/mp4" />
                                                </video>)}
                                            </td>
                                        : undefined}
                                        <td style={{ display: "none" }}>
                                            <button className="btn"
                                                style={{ margin : "1% 1% 1% 1%"}}
                                            >
                                                <i id={index} className="fa fa-edit"></i>
                                            </button>
                                            <button className="btn"
                                            >
                                                <i id={index} className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>)
                        })}
                    </tbody>
                </table>
            : <div className="alert alert-secondary" role="alert">
                No data available
              </div>}
              {this.state.descriptionSelectedRow ?
              <Modal isOpen={!!this.state.descriptionSelectedRow}>
                <ModalHeader
                    toggle={this.closeDescriptionModal}
                    style={{ color:"#524fa1" }}
                >
                    <b>{this.props.scenarioCatalogueData[parseInt(this.state.descriptionSelectedRow)].scenario_ui_id}</b> - Scenario Description
                </ModalHeader>
                <ModalBody>
                  <p>{this.props.scenarioCatalogueData[parseInt(this.state.descriptionSelectedRow)].scenario_description}</p>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={this.closeDescriptionModal}>Close</Button>
                </ModalFooter>
              </Modal>
              : undefined}
              {this.state.imageSelectedRow ?
              <Modal isOpen={!!this.state.imageSelectedRow}>
                <ModalHeader
                    toggle={this.closeImageModal}
                    style={{ color:"#524fa1" }}
                >
                    <b>{this.props.scenarioCatalogueData[parseInt(this.state.imageSelectedRow)].scenario_ui_id}</b> - Scenario Representation
                </ModalHeader>
                <ModalBody>
                    <div className="card card-body align-items-center">
                    <img alt="" style={{ height: "250px", maxWidth: "100%" }} src={`${baseUrl}${this.props.scenarioCatalogueData[parseInt(this.state.imageSelectedRow)].img.replace(/['"]+/g, '')}`}
                       ></img>
                   </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={this.closeImageModal}>Close</Button>
                </ModalFooter>
              </Modal>
              : undefined}
        </div>
    </section>
        )
    }
}
ScenarioCatalogueTable.propTypes={
scenarioCatalogueData:PropTypes.string,

}
ScenarioCatalogueTable.defaultProps= {
scenarioCatalogueData:[],
}

export default ScenarioCatalogueTable;
